import { alphabeticalSort } from 'shared'
import { HelpMessage } from 'utils/constants'
import { useNameColumn } from 'components/CIMSTable/common/hooks/useNameColumn'
import { CIMSColumn } from 'components/CIMSTable/CIMSColumn/types'
import UserTags from 'components/CIMSTags/common/UserTags'
import {
  Discipline,
  useDisciplinesTableContext,
} from '../../../DisciplinesTableContext'
import { useOptionalDescriptionColumn } from 'components/CIMSTable/common/hooks/useDescriptionColumn'

export const useColumns = (): CIMSColumn<Discipline>[] => {
  const { records } = useDisciplinesTableContext()
  return [
    useNameColumn({
      help: HelpMessage.DesignSubmittals.Disciplines.Name,
      width: 300,
      sort: { default: 'ascend' },
    }),
    useOptionalDescriptionColumn('Discipline'),
    {
      title: 'Approvers',
      width: 400,
      help: HelpMessage.DesignSubmittals.Disciplines.Approvers,
      render: ({ users }) => <UserTags users={users} />,
      filter: {
        with: 'callback',
        items: records
          ?.flatMap(({ users }) => users)
          .map(({ id, displayName, mail }) => ({
            text: displayName ?? mail,
            value: id,
          }))
          .sort(alphabeticalSort('text')),
        onFilter: (value, { users }) => users.some(({ id }) => id === value),
      },
    },
  ]
}
